import { type Ref, ref, watchEffect } from 'vue'
import { DEFAULT_FLOW_CURRENT_STEP } from '@/shared/constants/flow.constants'
import type { AvailableFlowRoutes, FlowStep } from '@/shared/types/flow.types'
import type { useFlowStepsResult } from './useFlowSteps.types'
import { LandingsRoutes } from '@/shared/types/router.types'

const step: Ref<FlowStep> = ref({
  next: LandingsRoutes.TRAVEL_MAIN,
  current: LandingsRoutes.TRAVEL_MAIN,
  prev: LandingsRoutes.TRAVEL_MAIN,
  index: 0,
})

export const useFlowSteps = (flowScheme: AvailableFlowRoutes[]): useFlowStepsResult => {
  const stepsCount = ref(flowScheme.length)
  const currentStep = ref(DEFAULT_FLOW_CURRENT_STEP)
  const flowSchemeWithHome: AvailableFlowRoutes[] = [LandingsRoutes.TRAVEL_MAIN, ...flowScheme]

  // TODO: добавить возможность переиспользовать в разных местах, сейчас работает в 1 месте
  watchEffect(() => {
    step.value.prev = flowSchemeWithHome[currentStep.value - 1]
    step.value.current = flowSchemeWithHome[currentStep.value]
    step.value.next = flowSchemeWithHome[currentStep.value + 1]
    step.value.index = currentStep.value
  })

  return {
    stepsCount,
    currentStep,
    step,
  }
}
